var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.show
    ? _c(
        "transition",
        {
          attrs: { name: "el-zoom-in-top" },
          on: { "before-leave": _vm.beforeLeave, "after-leave": _vm.doDestroy },
        },
        [
          _c(
            "div",
            { staticClass: "position-panel", style: _vm.style },
            [_vm._t("default")],
            2
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }